import { render, staticRenderFns } from "./OrganizationInspectionsTable.vue?vue&type=template&id=db946774&"
import script from "./OrganizationInspectionsTable.vue?vue&type=script&lang=js&"
export * from "./OrganizationInspectionsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports